import React, { useState } from 'react';
import { useNavigate } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import useDisableBrowserBack from "../hooks/useDisableBrowserBack";

function Intro({ screen }) {
  useDisableBrowserBack();

  const { t } = useTranslation();
  const navigate = useNavigate();
  const [step, setStep] = useState(screen ? screen : 0);
  const [initState, setInitState] = useState(true);

  const handleContinueButton = (e) => {
    e.preventDefault();
    if (step === 0) {
      setStep(1);
      setInitState(false);
      navigate("/app/game/intro/2" + window.location.search);
    } else if (step === 1) {
      setStep(2);
      setTimeout(() => {
        navigate("/app/game/onboard" + window.location.search);
      }, 1000);
    }
  }
  const handleBackButton = (e) => {
    e.preventDefault();
    if (step === 1) {
      setStep(0);
      setInitState(false);
      navigate("/app/game/intro/1" + window.location.search);
    }
  }

  return (
    <div className={`mobileContainer backgroundGold intro-screen`}>
      <div className="content-wrapper">
        <div className={`content-1 frameExpressive 
          ${step === 0 ? '_anim-in' : ''}
          ${step != 0 && !initState ? '_anim-out' : ''}`
        }>
          <p>{t('student.game.intro_1_1')}</p>
        </div>
        <div className={`content-2 speechBalloonSmall 
          ${step === 0 ? '_anim-in' : ''}
          ${step != 0 && !initState ? '_anim-out' : ''}`
        }>
          <p>{t('student.game.intro_1_2')}</p>
        </div>
      </div>
      <div className="content-wrapper">
        <div className={`content-3 frameExpressive 
          ${step === 1 ? '_anim-in' : ''}
          ${step != 1 && !initState ? '_anim-out' : ''}`
        }>
          <p>{t('student.game.intro_2_1')}</p>
        </div>
        <div className={`content-4 speechBalloonSmall 
          ${step === 1 ? '_anim-in' : ''}
          ${step != 1 && !initState ? '_anim-out' : ''}`
        }>
          <p>{t('student.game.intro_2_2')}</p>
        </div>
      </div>
      <div className={`navigationDrawer spread variant6 enableInAnimation`}>
        <a className="chromelessIconButton" onClick={handleBackButton}>
          {step === 1 && (
            <span className="icon icon-backward-simple"></span>
          )}
        </a>
        <a className="chromelessIconButton" onClick={handleContinueButton}>
          <span className="caption">{t('student.game.continue_label')}</span>
          <span className="icon icon-forward"></span>
        </a>
      </div>
    </div>
  );
}

export default Intro;